import { render, staticRenderFns } from "./camera-regions.item.vue?vue&type=template&id=c58b5b40&"
import script from "./camera-regions.item.vue?vue&type=script&lang=ts&"
export * from "./camera-regions.item.vue?vue&type=script&lang=ts&"
import style0 from "./camera-regions.item.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports